export const env ={
    DEV: "dev",
    STG: "stg",
    PROD: "prod"
}

export const formTypes ={
    LOGIN: "login",
    FORGOT_PASSWORD: "forgot_password"
}


export const rolesId = {
  THERAPIST: 27,
  WELLNESS_CHEF: 13,
  CHEF_ADMIN: 24
}

export const chefRolesId = [rolesId.WELLNESS_CHEF, rolesId.CHEF_ADMIN];

